import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";

const ProjectsProgress = ({
  totalProjectsProgress = 0,
  // totalCompleted = 0,
  // totalProjects = 8,
}) => {
  const progress = Math.max(0, Math.min(100, Number(totalProjectsProgress)));

  return (
    <Box
      sx={{
        background: "#8e24aa",
        borderRadius: 3,
        padding: 3,
        color: "#fff",
        boxShadow: "0px 8px 25px rgba(0,0,0,0.1)",
        width : "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, fontSize: "16px", textAlign: "left" }}
        >
          Project Progress
        </Typography>
        <FolderOpenOutlinedIcon sx={{ color: "#fff", fontSize: "20px" }} />
      </Box>

      {/* % Progress */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          fontSize: "32px",
          mb: "14px",
          textAlign: "left",
          lineHeight : 1,
        }}
      >
        {progress.toFixed(0)}%
      </Typography>

      {/* Completion Count */}
      {/* <Typography
        variant="body2"
        sx={{ opacity: 0.9, fontSize: "14px", mb: 1.5, textAlign: "left" }}
      >
        {totalCompleted}/{totalProjects} completed
      </Typography> */}

      {/* Linear Progress Bar */}
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height : 8,
          borderRadius: 5,
          backgroundColor: "#ffffff55",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#d0a5f8",
          },
        }}
      />
    </Box>
  );
};

export default ProjectsProgress;
